import { useEffect, useState } from "react";

const  useCountryValidators = ( ) => {
	const [country_validators,setCountryValidators] = useState([]);
	
	useEffect(()=>{
		import("stdnum").then(({stdnum})=>{
			setCountryValidators(stdnum);
		});
	},[]);
	return country_validators;
}

export const countryValidators = async () => {
	return  await import("stdnum").then(({stdnum})=>(stdnum));
}

export default useCountryValidators;